module.exports = {"please":"Please","logout":"logout","login":"login","clientContent":"<p><a href='/logout'>Log out</a> in order to view events as a Patron or return to the <a href='/events'>Box Office</a></p>","patronContent":"<p><a href='/login'>Log in</a> in order to view the Box Office.</p>"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Forbidden/locales/fr.json
// module id = 1756
// module chunks = 0